<template>
  <div class="wrapper" v-if="aItem">
    <van-row class="top" align="center">
      <van-row>
        <!--待付款-->
        <span class="stateText" v-if="aItem.final_state == 4">
          <img src="../../assets/images/orderdetail/pay.svg" />
          <div class="state">
            <span class="staus">
              等待买家付款
              <span class="stateTime">({{`剩余${counttime}分钟自动关闭`}})</span>
            </span>
            <span>订单编号：{{aItem.show_nbr}}</span>
          </div>
        </span>
        <!--交易失败-->
        <span class="stateText" v-if="aItem.final_state == 10">
          <img src="../../assets/images/orderdetail/payclose.svg" />
          <div class="state">
            <span class="staus">
              交易关闭
              <span class="stateTime">({{aItem.create_time}})</span>
            </span>
            <span>订单编号：{{aItem.show_nbr}}</span>
          </div>
        </span>
        <!--待发货-->
        <span class="stateText" v-if="aItem.final_state == 6">
          <img src="../../assets/images/orderdetail/paided.png" />
          <div class="state">
            <span class="staus">
              买家已付款
              <span class="stateTime">({{aItem.create_time}})</span>
            </span>
            <span>订单编号：{{aItem.show_nbr}}</span>
          </div>
        </span>
        <!--待收货-->
        <span class="stateText" v-if="aItem.final_state == 7">
          <img src="../../assets/images/orderdetail/paysend.svg" />
          <div class="state">
            <span class="staus">
              卖家已发货
              <span class="stateTime">({{aItem.create_time}})</span>
            </span>
            <span>订单编号：{{aItem.show_nbr}}</span>
          </div>
        </span>
        <!--交易成功-->
        <span class="stateText" v-if="aItem.final_state == 8">
          <img src="../../assets/images/orderdetail/paysuccess.svg" />
          <div class="state">
            <span class="staus">
              交易成功
              <span class="stateTime">({{aItem.create_time}})</span>
            </span>
            <span>订单编号：{{aItem.show_nbr}}</span>
          </div>
        </span>
      </van-row>
    </van-row>
    <div class="kb">
      <van-row class="address" type="flex">
        <div class="address-img">
          <img src="./../../assets/images/orderdetail/address.svg" alt />
        </div>
        <van-row>
          <div class="address-top">
            <span class="contacts">收货人：{{aItem.contacts}}</span>
            <span class="phone_no">{{aItem.phone_no}}</span>
          </div>
          <span class="address-bottom">收货地址：{{aItem.full_address}}</span>
        </van-row>
      </van-row>
      <!--商品行-->
      <div class="goodlistbox">
        <div class="goodlist-c" v-for="(item,index) in list" :key="index">
          <van-row class="goodlist">
            <van-row type="flex" style="padding-bottom: 0.24rem;" @click.stop.native="$router.push(`${item.rule_type=='1'?'listdetail':'sourceListdetail'}?nbr=${item.commodity_nbr}`)">
              <img
                :src="item.inventory_logo||item.commodity_first_pic + `${imgCrop}resize,w_300`"
                alt
              />
              <van-row class="goodinfo">
                <div>
                  <van-row class="name more-h">{{item.commodity_name}}</van-row>
                  <van-row
                    class="sigle-h"
                    @click.native.stop="showProperty(item.property)"
                    type="flex"
                    align="center"
                  >
                    <van-col class="property">{{item.property}}</van-col>
                    <van-col class="quantity">x{{item.quantity}}</van-col>
                  </van-row>
                </div>
                <van-row type="flex" justify="space-between" align="center" class="goodinfo-bottom">
                  <van-col>
                    <span>￥{{item.sell_price}}</span>
                  </van-col>
                  <van-col>
                    <van-button
                      round
                      type="default"
                      size="small"
                      class="default"
                      v-if="((item.is_refunding == 0&&item.refund.refund_quantity > 0&&aItem.final_state==7)||
                      (item.is_refunding == 0&&item.refund.refund_quantity > 0&&aItem.final_state == 6&&aItem.is_group==0)||
                      (item.is_refunding == 0&&item.refund.refund_quantity > 0&&aItem.final_state == 6&&aItem.is_group==1&&aItem.group_is_full==1)||
                      (item.is_15day==1&&aItem.final_state == 8&&item.is_refunding==0&&item.refund.refund_quantity > 0))"
                      @click.stop.native="toBackApply(item)"
                    >申请售后</van-button>
                    <div v-else-if="item.is_refunding == 1" class="refundBox">
                      <span class="stausText">售后处理中</span>
                      <van-button
                      round
                      type="default"
                      size="small"
                      class="refundBtn"
                      @click.stop.native="toRefundList"
                      >查看售后</van-button>
                    </div>
                    <span class="stausText" v-else-if="item.is_refunding == 0&&item.refund.refund_quantity==0">售后处理成功</span>
                  </van-col>
                </van-row>
              </van-row>
            </van-row>
            <div class="btn express" v-if="item.express_id">
              <van-col class="expressImg">
                <img src="../../assets/images/orderdetail/express.svg" alt />
              </van-col>
              <van-col class="expressText">
                <van-row
                  :style="{textAlign:'left',fontSize:'0.24rem'}"
                >快递公司：{{item.express_name||'无'}}</van-row>
                <van-row :style="{textAlign:'left',fontSize:'0.24rem',marginTop:'0.08rem'}">
                  快递单号：{{item.express_id||'无'}}
                  <span class="expressCopy cbtn1" data-clipboard-action="copy" :data-clipboard-text="item.express_id" @click="copy">复制</span>
                  <van-button
                    class="copyBtn2"
                    @click.native="$router.push({path:'/logistics',query:{nbr:item.commodity_record_nbr,final_phone:aItem.phone_no.slice(7,11),supNbr:userInfo.nbr}})"
                  >查看</van-button>
                  <!-- <van-button class="copyBtn2 cbtn1" data-clipboard-action="copy" :data-clipboard-text="item.express_id" @click="copy">复制</van-button> -->
                </van-row>
              </van-col>
              <!--<van-button round type="default" size="small" class="default" v-if="item.status1 ==4">退款失败</van-button>-->
            </div>
          </van-row>
        </div>
      </div>
    </div>
    <van-cell-group class="list">
      <van-cell title="商品金额" :value="'¥'+aItem.commodity_amount" />
      <van-cell title="运费" v-if="aItem.postage>0" :value="'+￥'+aItem.postage" />
      <van-cell title="运费险" v-if="aItem.postage_safe>0" :value="'+￥'+aItem.postage_safe" />
      <van-cell title="满减折扣" v-if="aItem.area_discount_amount>0" :value="'-￥'+aItem.area_discount_amount"/>
      <van-cell title="鲸灵会场抵扣" v-if="aItem.jl_discount_amount>0" :value="'-￥'+aItem.jl_discount_amount"/>
      <van-cell
        class="border"
        v-if="aItem.coupon_amount>0"
        title="优惠"
        :value="'-￥'+aItem.coupon_amount"
      />
      <van-row class="subtotal">
        共{{list.length}}件
        &nbsp;&nbsp;&nbsp;&nbsp;实付款：
        <span>¥{{aItem.sum_amount}}</span>
      </van-row>
    </van-cell-group>
    <van-row class="orderbox">
      <van-col class="orderbox-title">
        <div></div>
        <span>订单信息</span>
      </van-col>
      <van-col style="color:#333" v-if="aItem.message">{{'买家留言：'+ aItem.message}}</van-col>
      <van-col>
        订单编号：{{aItem.show_nbr}}
        <van-button
          class="copyBtn right cbtn2"
          @click="copy"
          data-clipboard-action="copy"
          :data-clipboard-text="aItem.show_nbr"
        >复制</van-button>
      </van-col>
      <van-col v-if="aItem.create_time">{{'下单时间：'+aItem.create_time}}</van-col>
      <van-col v-if="aItem.paid_time">{{'付款时间：'+aItem.paid_time}}</van-col>
      <van-col v-if="aItem.deliver_time">{{'发货时间：'+aItem.deliver_time}}</van-col>
      <van-col v-if="aItem.received_time">{{'成交时间：'+aItem.received_time}}</van-col>
    </van-row>
    <van-row class="contactbox">
      <van-col class="contact-text" @click.native="showService">
        <img src="../../assets/images/orderdetail/contact.svg" alt />
        <span>联系客服</span>
      </van-col>
    </van-row>
    <van-row
      class="btn bottom"
      v-if="
      aItem.final_state == 10
      ||aItem.final_state == 4
      ||(aItem.final_state == 7&&aItem.is_refunding==0)
      ||(aItem.final_state === '8')
      "
    >
      <van-button
        round
        type="default"
        size="small"
        class="default"
        v-if="aItem.final_state == 10||aItem.final_state == 8"
        @click.native="delorder(aItem.order_nbr)"
      >删除订单</van-button>
      <van-button
        round
        type="default"
        size="small"
        class="default"
        v-if="aItem.final_state == 4"
        @click.native="cancelorder(aItem.order_nbr)"
      >取消订单</van-button>
      <!--<van-button round type="default" size="small" class="default" v-if="aItem.final_state == 6 || aItem.final_state == 7"
                  @click.native="$router.push({path:'/logistics',query:{nbr:$route.query.nbr}})">查看物流
      </van-button>-->
      <van-button
        round
        type="default"
        size="small"
        class="purple1"
        v-if="aItem.final_state == 4"
        @click.native.stop="gopay(aItem.order_nbr,aItem.sum_amount,aItem.group_leader_nbr, aItem.is_leader)"
      >立即付款</van-button>
      <!-- <van-button
        round
        type="default"
        size="small"
        class="default"
        v-if="aItem.final_state == 6&&aItem.is_refunding!=0&&aItem.is_group==0"
        @click.native="notuishow = true"
      >取消退款</van-button>
      <van-button
        round
        type="default"
        size="small"
        class="default"
        v-if="aItem.final_state == 6&&aItem.is_refunding!=0&&aItem.is_group==1&&aItem.group_is_full==1"
        @click.native="notuishow = true"
      >取消退款</van-button> -->
      <van-button
        round
        type="default"
        size="small"
        class="purple"
        style="background:#E52B25;color:#fff"
        v-if="aItem.final_state == 7&&aItem.is_refunding==0"
        @click.native="confirmreceipt($route.query.nbr)"
      >确认收货</van-button>
      <van-button
        round
        type="default"
        size="small"
        class="purple"
        v-if="aItem.final_state === '8' && aItem.comment_state === '1'"
        @click.native.stop="$router.push({path:'/evaluate',query:{nbr:aItem.order_nbr,supNbr:userInfo.nbr}})"
      >评价</van-button>
    </van-row>
    <pay
      :order_number="order_number"
      :paymoney="paymoney"
      :groupLeaderNbr="groupLeaderNbr"
      :state="state"
      ref="pay"
      @goback="goback"
      @paysuccess="paysuccess"
    ></pay>
    <!--取消订单-->
    <van-popup v-model="show" :close-on-click-overlay="false">
      <van-row class="popup">
        <van-row class="content" type="flex" justify="center" align="center">确定要取消订单吗？</van-row>
        <van-row>
          <van-col class="cancel" @click.native="show=false">取消</van-col>
          <van-col class="confirm" @click.native="confirm">确定</van-col>
        </van-row>
      </van-row>
    </van-popup>
    <!--取消订单-->
    <van-popup v-model="deleteShow" :close-on-click-overlay="false">
      <van-row class="popup">
        <van-row class="content" type="flex" justify="center" align="center">确定要删除订单吗？</van-row>
        <van-row>
          <van-col class="cancel" @click.native="deleteShow=false">取消</van-col>
          <van-col class="confirm" @click.native.stop="confirmDelete">确定</van-col>
        </van-row>
      </van-row>
    </van-popup>
    <!--确认全部退款-->
    <van-popup v-model="alltTshow" :close-on-click-overlay="false">
      <van-row class="popup">
        <van-row class="content" type="flex" justify="center" align="center">确定申请退款吗？</van-row>
        <van-row>
          <van-col class="cancel" @click.native="alltTshow=false">取消</van-col>
          <van-col class="confirm" @click.native.stop="confirmAllTOk">确定</van-col>
        </van-row>
      </van-row>
    </van-popup>
    <!--确认退款-->
    <van-popup v-model="shouhuoshow" :close-on-click-overlay="false">
      <van-row class="popup" style="height:3.6rem;">
        <van-row
          class="content"
          type="flex"
          justify="center"
          align="center"
          style="flex-direction: column;height:2.51rem;"
        >
          <span style="margin-bottom:0.3rem;">温馨提示</span>
          <span>确认收货后将无法退款</span>
        </van-row>
        <van-row>
          <van-col class="cancel" @click.native="shouhuoshow=false">取消</van-col>
          <van-col class="confirm" @click.native.stop="confirmshouhuo">确认收货</van-col>
        </van-row>
      </van-row>
    </van-popup>
    <!--确认收货-->
    <van-popup v-model="tuishow" :close-on-click-overlay="false">
      <van-row class="popup">
        <van-row class="content" type="flex" justify="center" align="center">确定申请退款吗？</van-row>
        <van-row>
          <van-col class="cancel" @click.native="tuishow=false">取消</van-col>
          <van-col class="confirm" @click.native.stop="replacement">确定</van-col>
        </van-row>
      </van-row>
    </van-popup>
    <!-- 确定取消退款吗 -->
    <van-popup v-model="notuishow" :close-on-click-overlay="false">
      <van-row class="popup">
        <van-row class="content" type="flex" justify="center" align="center">确定取消退款吗？</van-row>
        <van-row>
          <van-col class="cancel" @click.native="notuishow=false">取消</van-col>
          <van-col class="confirm" @click.native.stop="tuiOk">确定</van-col>
        </van-row>
      </van-row>
    </van-popup>
    <!--规格弹窗-->
    <van-popup v-model="propertyModal" :close-on-click-overlay="true">
      <van-row class="popup1">
        <van-row class="title">已选规格：</van-row>
        <van-row class="propertyText">{{propertyText}}</van-row>
      </van-row>
    </van-popup>

    <!-- 客服弹窗 -->
    <van-popup v-model="show1" style="border-radius: 0.2rem;">
      <div class="servicebox">
        <img
          class="serviceimg"
          @click="show1 = false"
          src="./../../assets/images/information/Close.svg"
          alt
        />
        <div class="servicespan">
          <p class="wechat">有米日记服务中心</p>
          <span>有米日记售后系统上线啦！</span>
          <span>长按识别小程序码，即可体验全新售后体验</span>
          <!--<span>菜单底部直接联系客服</span>-->
        </div>
        <div class="codeimg">
          <img src="./../../assets/images/xcx_qrcode.jpg" alt />
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import pay from "./pay";
import weChatShareApi from "../../assets/js/weChatShare";
import { handleText } from "./../../assets/js/tool";
export default {
  components: {
    pay: pay
  },
  props: {},
  mixins: [weChatShareApi],
  data() {
    return {
      counttime: "",
      show: false,
      show1: false,
      paymoney: "0.00", //付款的钱
      order_number: "", //付款的订单号
      list: "",
      aItem: "",
      cancelid: "",
      shouhuoid: "", //确认收货的id
      shouhuoshow: false, //
      tuishow: false,
      notuishow: false,
      alltTshow: false,
      allTid: "",
      tuiid: "", //
      tuiid_parent: "", //
      deleteShow: false,
      deleteid: "",
      propertyText: "",
      propertyModal: false,
      supUserNbr: "",
      groupLeaderNbr:'',
      state:'',
      info:{},
    };
  },
  watch: {},
  methods: {
    toRefundList(item){
      this.$router.push({path:'/replacementlist'})
    },
    toBackApply(item){
      this.$router.push({path:'/replaceType',query:{
        nbr:item.commodity_record_nbr,
        supNbr:this.userInfo.nbr,
        type:Number(this.aItem.final_state)-5
      }
     })
    },
    showService() {
      // this.show1 = true;
      let item = this.aItem
      let note = {
        orderNbr: item.show_nbr
      }
      let time=new Date(item.create_time).getTime()/1000
      let adminUrl=`https://ymrjmanager.kjyoumi.com/ysfIframe?openid=${this.userInfo.nbr}&note=${JSON.stringify(note)}`
      let goods = this.list[0]
      let orderInfo=`tmptype=order&tmpTitle=${encodeURIComponent(goods.commodity_name)}&tmporderThumb=${encodeURIComponent(goods.commodity_first_pic)}&tmporderid=${item.show_nbr}&tmpordertime=${time}&tmpordernum=${goods.quantity}&tmporderprice=${item.sum_amount}&tmporderstaffurl=${encodeURIComponent(adminUrl)}&isauto=0`
      let url = `https://kefu.kjyoumi.com/api/mobileweb/home?channel_id=34483&channel_key=34483zkeq&wechatapp_id=345097&key=76967s450&openid=${this.userInfo.nbr}&nickName=${encodeURIComponent(this.info.nick_name)}&avatarUrl=${encodeURIComponent(this.info.head_pic)}&mobile=${this.info.phone_no||''}&note=${JSON.stringify(note)}&${orderInfo}`
      let u = navigator.userAgent
      let isandroid = u.indexOf('android') > -1 || u.indexOf('adr') > -1;
      if(isandroid) url=url+'&isvivo=1'
      // window.open(url)
      this.$router.push({
        path: "/iframe",
        query: {
          title: encodeURIComponent('在线客服'),
          url: encodeURIComponent(url),
        },
      });
    },
    showProperty(text) {
      this.propertyText = text;
      this.propertyModal = true;
    },
    copy() {
      let cbtn1 = new this.$clipboard(".cbtn1");
      let cbtn2 = new this.$clipboard(".cbtn2");
      cbtn1.on("success", e => {
        this.$toast({
          message: "复制成功",
          duration: 2000
        });
      });
      cbtn1.on("error", e => {
        this.$toast({
          message: "复制失败",
          duration: 2000
        });
      });
      cbtn2.on("success", e => {
        this.$toast({
          message: "复制成功",
          duration: 2000
        });
      });
      cbtn2.on("error", e => {
        this.$toast({
          message: "复制失败",
          duration: 2000
        });
      });
    },
    /**
     *删除订单
     */
    delorder(nbr) {
      this.deleteShow = true;
      this.deleteid = nbr;
    },
    confirmDelete() {
      let that = this;
      const toast = this.$toast({
        type: "loading",
        message: "正在提交...",
        duration: 0,
        mask: true
      });
      this.$commonPost({
        jydm: "flow_10000",
        flow_10000: {
          sub_flow: "flow_30029",
          nbr: this.deleteid
        }
      })
        .then(resp => {
          this.$toast({
            message: "删除订单成功",
            duration: 1000
          });
          this.deleteShow = false;
          this.$store.commit("SENDpayment", 1);
          setTimeout(function() {
            that.$router.go(-1);
          }, 100);
        })
        .catch(err => {
          this.deleteShow = false;
          this.$toast({
            message: err.message,
            duration: 2000
          });
        });
    },
    /**
     * 全部退款
     */
    confirmAllT(nbr) {
      this.allTid = nbr;
      this.alltTshow = true;
    },
    confirmAllTOk() {
      const toast = this.$toast({
        type: "loading",
        message: "正在提交...",
        duration: 0,
        mask: true
      });
      this.$post("/api/customer/refundOrder/applyConfirm", {
        userNbr: this.userInfo.nbr,
        orderNbr: this.allTid
      })
        .then(data => {
          toast.clear();
          if (data.code == 200) {
            let resp = data.object.resp;
            if (resp.resp_code == 0 && resp.resp_result == 0) {
              this.alltTshow = false;
              this.$store.commit("SENDpayment", this.$route.query.nbr);
              this.$router.go(-1);
              this.$toast({
                message: "退款申请成功",
                duration: 2000
              });
            } else {
              this.$toast({
                message: resp.resp_msg,
                duration: 2000
              });
            }
          } else {
            this.$toast({
              message: data.message,
              duration: 2000
            });
          }
        })
        .catch(err => {
          toast.clear();
          this.$toast({
            message: "您现在的网络不稳定，请稍后再试",
            duration: 2000
          });
        });
    },
    /**
     * 确认收货
     * @param b_id 小订单号
     */
    confirmreceipt(b_id) {
      this.shouhuoid = b_id;
      this.shouhuoshow = true;
    },
    confirmshouhuo() {
      // 加载框子
      const toast = this.$toast({
        type: "loading",
        message: "正在提交...",
        duration: 0,
        mask: true
      });

      this.$post("api/customer/comfirmOrder", {
        userNbr: this.userInfo.nbr,
        orderNbr: this.shouhuoid
      })
        .then(res => {
          if (res.code == "200") {
            let resp = res.object.resp;
            if (resp.resp_code == "0" && resp.resp_result == "0") {
              this.$toast({
                message: "确认收货成功",
                duration: 2000
              });
              this.$store.commit("SENDreceive", this.$route.query.nbr);
              this.getdata();
              this.shouhuoshow = false;
            } else {
              this.$toast({
                message: resp.resp_msg,
                duration: 2000
              });
            }
          } else {
            this.$toast({
              message: res.message,
              duration: 2000
            });
          }
        })
        .catch(err => {
          this.$toast({
            message: err.message,
            duration: 2000
          });
        });
    },
    /**
     * 取消订单
     */
    cancelorder(b_id) {
      this.cancelid = b_id;
      this.show = true;
    },
    confirm() {
      // 加载框子
      const toast = this.$toast({
        type: "loading",
        message: "正在提交...",
        duration: 0,
        mask: true
      });
      this.$commonPost({
        jydm: "flow_10000",
        flow_10000: {
          sub_flow: "flow_30032",
          order_nbr: this.cancelid
        }
      })
        .then(resp => {
          this.show = false;
          this.$toast({
            message: "订单取消成功",
            duration: 1000
          });
          this.$store.commit("SENDpayment", 1);
          this.$router.go(-1);
        })
        .catch(err => {
          this.show = false;
          this.$toast({
            message: err.message,
            duration: 2000
          });
        });
    },
    /**
     *去付款
     */
    gopay(orders_num, money, groupLeaderNbr, isLeader) {
      this.paymoney = money;
      this.order_number = orders_num;
      this.groupLeaderNbr = groupLeaderNbr||'';
      this.state = isLeader||'';
      this.$refs.pay.showpay();
    },
    /**
     *支付失败
     */
    goback() {},
    /**
     *支付成功 刷新页面并且设置  SENDpayment 为1 刷新我的订单列表
     *
     */
    paysuccess() {
      this.$store.commit("SENDpayment", 1);
      //this.$router.go(-1);
    },
    /**
     * 退货退款
     * @param status 订单状态
     * @param s_id 小订单id
     */
    replacement() {
      let that = this;
      that.$router.push({
        path: "/replacement",
        query: {
          nbr: this.tuiid,
          parentNbr: this.tuiid_parent,
          supNbr: this.userInfo.nbr
        }
      });
    },
    /**
     * 取消退款
     */
    tuiOk() {
      this.$commonPost({
        jydm: "flow_10000",
        flow_10000: {
          sub_flow: "flow_40021",
          user_nbr: this.userInfo.nbr,
          nbr: this.aItem.refund_nbr
        }
      })
        .then(response => {
          this.$toast({
            message: "取消退款成功!",
            duration: 2000
          });
          this.getdata();
          this.notuishow = false;
        })
        .catch(err => {
          this.$toast({
            message: err.message,
            duration: 2000
          });
        });
    },
    /**
     * 待付款倒计时
     */
    countdownfunciton(orderCreateTime) {
      const that = this;
      let orderCloseTime = parseFloat(
        localStorage.getItem("otherConfig_10022") || "30"
      );
      let remainingTime =
        new Date(orderCreateTime.replace(/\-/g, "/")).getTime() +
        60 * orderCloseTime * 1000 -
        new Date().getTime();
      this.counttime = remainingTime > 0 ? Math.ceil(remainingTime / 60000) : 0;
      // this.countdown = setInterval(function() {
      //   let time =
      //     new Date(orderCreateTime.replace(/\-/g, "/")).getTime() +
      //     60 * 30 * 1000 -
      //     new Date().getTime(); // 30分钟时间付款
      //   if (time < 0) {
      //     that.counttime = "00时00分00秒";
      //     clearInterval(that.countdown);
      //     that.$store.commit("SENDpayment", 1);
      //   } else {
      //     let leftHours =
      //       parseInt(time / 1000 / 60 / 60, 10) < 10
      //         ? "0" + parseInt(time / 1000 / 60 / 60, 10)
      //         : parseInt(time / 1000 / 60 / 60, 10);
      //     let leftMinutes =
      //       parseInt((time / 1000 / 60) % 60, 10) < 10
      //         ? "0" + parseInt((time / 1000 / 60) % 60, 10)
      //         : parseInt((time / 1000 / 60) % 60, 10);
      //     let leftSeconds =
      //       parseInt((time / 1000) % 60, 10) < 10
      //         ? "0" + parseInt((time / 1000) % 60, 10)
      //         : parseInt((time / 1000) % 60, 10);
      //     that.counttime =
      //       leftHours + "时" + leftMinutes + "分" + leftSeconds + "秒";
      //   }
      // }, 1000);
    },
    getdata() {
      let toast = this.$toast({
        mask: false,
        duration: 0,
        type: "loading"
      });
      this.$commonPost({
        jydm: "flow_30011",
        flow_30011: {
          order_nbr: this.$route.query.nbr,
          wechat_version: 1
        }
      })
        .then(response => {
          let arr = [];
          if (response.commodity) {
            if (response.commodity.length > 0) {
              arr = response.commodity;
            } else {
              arr.push(response.commodity);
            }
          }
          if (response.final_state === "4") {
            this.countdownfunciton(response.create_time);
          }
          this.list = arr;
          response.full_address = handleText(response.full_address);
          this.aItem = response;
          this.$forceUpdate(); //重绘
          toast.clear();
        })
        .catch(err => {
          this.$toast({
            message: err.message,
            duration: 2000
          });
        });
      /*this.$post('/api/orders/orders_detail', {id: this.$route.query.b_id}).then(res => {
          if (res.code == 1) {
            this.list = res.data;
            if (res.data.status == 0) {
              this.countdownfunciton(res.data.create_time)
            }
          } else {
            this.$toast(res.msg);
            setTimeout(function () {
              that.$router.go(-1)
            }, 1000)
          }
        })*/
    },
    initPage() {
      if (this.$route.query.supNbr == this.userInfo.nbr) {
        this.getdata();
      } else {
        return this.$router.push({
          path: "index",
          query: { supNbr: this.userInfo.nbr }
        });
      }
      let option = {
        title: "有米@" + this.userInfo.name + "的店铺",
        desc: "欢迎光临我的店铺",
        link: location.origin + "/?supNbr=" + this.userInfo.nbr,
        images: this.userInfo.imgUrl
      };
      this.weChatShare(option);
      this.getUserInfo();
    },
    getUserInfo(){
      this.$commonPost({
        jydm: "flow_10003",
        flow_10003: {
          user_nbr: this.userInfo.nbr,
        },
      }).then((resp) => {
        this.info = resp;
      }).catch((err) => {});
    },
  },
  created() {},
  mounted() {
    document.title = "订单详情";
    this.initPage();
  },
  beforeRouteLeave(to, from, next) {
    //clearInterval(this.countdown);
    next();
  }
};
</script>
<style scoped lang='stylus'>
.van-button::before {
  background-color: transparent;
}

.van-cell >>> .van-cell__value {
  color: #333;
}
</style>
<style scoped lang='less'>
.kb {
  background: #fff;
  position: relative;
  padding-top: 1.28rem;
}
.goodlistbox .goodlist .goodinfo .stausText{
  font-size: .2rem;
  color: #FF9E00;
}
.stateText {
  display: flex;
  align-items: center;
  img {
    width: 0.48rem;
    height: 0.48rem;
    margin-right: 0.16rem;
  }
  .state {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    height: 0.76rem;
    .staus {
      font-size: 0.3rem;
    }
    span {
      font-size: 0.24rem;
      color: #fff;
    }
  }
}
.stateTime {
  font-size: 0.24rem;
}
.sigle-h {
  margin-top: 0.1rem;
  height: 0.62rem;
  line-height: 0.3rem;
  width: 4.84rem;
  justify-content: space-between;
  .property {
    width: 3.8rem;
    word-break: break-all;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    word-break: break-all;
    white-space: normal;
    font-size: 0.22rem;
  }
  .quantity {
    color: #333;
    font-size: 0.24rem;
  }
}
.wrapper {
  width: 100%;
  min-height: calc(100vh - 1.78rem);
  background: #f5f5f5;
  //background: #f5f5f5;
  padding-bottom: 1.78rem;
}

.top {
  height: 2.12rem;
  padding: 0.28rem;
  box-sizing: border-box;
  font-size: 0.32rem;
  color: #ffffff;
  background-image: linear-gradient(0deg, #fe6664 0%, #e52b25 100%);
  padding-top: 0.31rem;
}

.popup1 {
  width: 6.3rem;
  min-height: 3.2rem;
  .title {
    margin: 0.48rem 0.4rem 0.2rem;
    color: #333;
    font-weight: bold;
  }
  .propertyText {
    margin: 0 0.4rem 0.5rem;
    color: #333;
    line-height: 0.4rem;
  }
}
.address {
  height: 1.68rem;
  padding: 0.25rem 0.3rem;
  box-sizing: border-box;
  background: #ffffff;
  width: 7.02rem;
  //margin: -.7rem auto 0;
  border-radius: 0.2rem;
  box-shadow: 0 0.02rem 0.14rem 0 rgba(239, 66, 70, 0.18);
  position: absolute;
  left: 50%;
  top: 0;
  transform: translate(-50%, -43%);
  .address-img {
    height: 100%;
    display: flex;
    align-items: center;
    img {
      width: 0.44rem;
      height: 0.44rem;
    }
  }

  .address-top {
    position: relative;
    width: 5.5rem;
    .contacts {
      width: 3.4rem;
      word-break: break-all;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
      word-break: break-all;
      white-space: normal;
    }
    .phone_no {
      position: absolute;
      right: 0.5rem;
      top: 0;
    }
  }
  .address-bottom {
    width: 5.5rem;
    word-break: break-all;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    word-break: break-all;
    white-space: normal;
  }
  span {
    font-size: 0.24rem;
    line-height: 0.33rem;
  }
  .van-row {
    margin-left: 0.24rem;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    color: #333333;
  }
  .van-row:after {
    display: none;
  }
}

.goodlistbox {
  background: #ffffff;
  box-sizing: border-box;
  .goodlist {
    padding-top: 0.26rem;
    border-bottom: 0.1rem solid #f5f5f5;
    img {
      width: 2rem;
      height: 2rem;
      margin-left: 0.24rem;
      object-fit: cover;
    }
    .goodinfo {
      flex: 1;
      width: 100%;
      margin-left: 0.2rem;
      margin-right: 0.24rem;
      font-size: 0.24rem;
      color: #999999;
      line-height: 0.34rem;
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      .name {
        color: #333333;
        width: 4.84rem;
        font-weight: bold;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        word-break: break-all;
        white-space: normal;
      }
      span {
        font-size: 0.28rem;
        color: #e52b25;
      }
      .goodinfo-bottom {
        position: relative;
      }
      .refundBox{
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
      }
      .refundBtn{
        margin-left: .14rem;
        width: 1.12rem;
        font-size: 0.2rem;
        height: 0.4rem;
        border: 1px solid #333;
        display: flex;
        align-items: center;
        justify-content: center;
        line-height: 0;
        padding: 0;
        span {
          color: #333;
          font-size: 0.2rem;
        }
      }
      .default {
        position: absolute;
        right: 0;
        top: 50%;
        width: 2.24rem;
        font-size: 0.4rem;
        height: 0.8rem;
        border: 1px solid #333;
        display: flex;
        align-items: center;
        justify-content: center;
        line-height: 0;
        padding: 0;
        transform: scale(0.5) translateY(-50%);
        transform-origin: 100% 0%;
        span {
          color: #333;
          font-size: 0.4rem;
        }
      }
    }
    .goodinfo:after {
      display: none;
    }
  }
  .goodlist-c:last-child .goodlist {
    border-bottom: none;
  }
  .express {
    padding: 0.22rem 0.24rem;
    border-top: 1px solid #eee;
    border-bottom: 1px solid #eee;
    height: 1.16rem;
    box-sizing: border-box;
    position: relative;
    display: flex;
    align-items: center;
    .expressImg {
      height: 100%;
      display: flex;
      align-items: center;
      img {
        width: 0.4rem;
        height: 0.4rem;
        margin-right: 0.22rem;
      }
    }
    .expressCopy{
      display: inline-block;
      margin-left: .24rem;
      font-size: .24rem;
      color: #E52B25;
    }
    .copyBtn2 {
      position: absolute;
      top: 50%;
      right: 0.24rem;
      width: 1.92rem;
      height: 0.8rem;
      line-height: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 0.4rem;
      padding: 0;
      margin: 0;
      transform: translateY(-50%) scale(0.5);
      transform-origin: 100% 50%;
      border: 1px solid #333;
    }
  }
}

.list {
  .van-cell {
    font-size: 0.28rem;
    padding: 0.25rem 0.24rem;
    box-sizing: border-box;
    line-height: 0.4rem;
    color: #333333;
  }
  .van-cell::after {
    content: none;
  }
  .border::before {
    content: none;
  }
  .border::after {
    content: " ";
    position: absolute;
    pointer-events: none;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    left: 15px;
    right: 0;
    bottom: 0;
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
    border-bottom: 1px solid #ebedf0;
  }
  .van-cell__title {
    flex: 1;
  }
  .van-cell__value {
    flex: 1;
  }
  .subtotal {
    height: 0.8rem;
    font-size: 0.24rem;
    padding: 0 0.28rem;
    color: #333333;
    text-align: right;
    line-height: 0.8rem;
    border-bottom: 0.2rem solid #f5f5f5;
    span {
      color: #e52b25;
      font-size: 0.32rem;
    }
  }
}

.orderbox {
  padding: 0 0.24rem;
  padding-bottom: 0.24rem;
  font-size: 0.24rem;
  color: #999999;
  line-height: 0.41rem;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border-bottom: 1px solid #eee;
  .orderbox-title {
    color: #333;
    font-size: 0.28rem;
    height: 0.88rem;
    display: flex;
    align-items: center;
    div {
      background: #e52b25;
      height: 0.3rem;
      width: 0.04rem;
      margin-right: 0.08rem;
    }
    span {
      line-height: 0.88rem;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}

.orderbox:after {
  display: none;
}
.contactbox {
  background: #ffffff;
  display: flex;
  .contact-text {
    height: 0.8rem;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 0.4rem;
      height: 0.4rem;
      margin-right: 0.14rem;
    }
  }
}
.bottom {
  border-top: 1px solid #eee;
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 1.08rem;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  /*padding: 0.2rem 0;*/
}

.btn {
  text-align: right;
  background: #ffffff;
  .default {
    margin-right: 0.24rem;
    width: 1.86rem;
    color: #333;
    height: 0.66rem;
    font-size: 0.28rem;
    border: 1px solid #333;
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 0.66rem;
  }
  .purple {
    color: #e52b25;
    border: 1px solid #e52b25;
    margin-right: 0.24rem;
    width: 1.86rem;
    height: 0.66rem;
    font-size: 0.28rem;
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 0.66rem;
  }
  .purple1 {
    margin-right: 0.24rem;
    width: 1.86rem;
    border: 1px solid #e52b25;
    height: 0.66rem;
    background: #e52b25;
    color: #fff;
    font-size: 0.28rem;
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 0.66rem;
  }
}
.copyBtn {
  padding: 0 0.11rem;
  font-size: 0.24rem;
  height: 0.37rem;
  line-height: 0.37rem;
  border-radius: 0;
  margin-left: 0.05rem;
  border: none;
}
.copyBtn.right {
  color: #e52b25;
  float: right;
}

/*取消订单*/
.van-popup {
  border-radius: 0.18rem;
}

.popup {
  width: 6.14rem;
  height: 3.04rem;
  .content {
    font-weight: 400;
    height: 1.96rem;
    text-align: center;
    font-size: 0.3rem;
    color: #333333;
    border-bottom: 1px solid #eeeeee;
  }
  .cancel {
    height: 1.07rem;
    text-align: center;
    line-height: 1.07rem;
    width: 50%;
    font-weight: 500;
    font-size: 0.3rem;
    color: #333333;
    border-right: 1px solid #eeeeee;
  }
  .confirm {
    height: 1.07rem;
    text-align: center;
    line-height: 1.07rem;
    width: 50%;
    font-size: 0.3rem;
    font-weight: 500;
    color: #e52b25;
  }
}
.servicebox {
  width: 6.14rem;
  height: 7.66rem;
  background: #ffffff;
  box-shadow: 0 0.02rem 0.34rem 0 rgba(239, 51, 66, 0.12);
  .serviceimg {
    width: 0.4rem;
    height: 0.4rem;
    position: absolute;
    top: 0.2rem;
    right: 0.2rem;
  }
  .servicespan {
    padding-top: 0.75rem;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    font-size: 0.26rem;
    color: #999;
    text-align: center;
    margin-bottom: 0.62rem;
    span {
      line-height: 0.4rem;
    }
    .wechat {
      font-size: 0.4rem;
      color: #000000;
      font-weight: bold;
      margin-bottom: 0.1rem;
      line-height: 0.56rem;
    }
  }
  .codeimg {
    display: flex;
    justify-content: center;
    align-items: center;
    background-position: center;
    img {
      width: 4rem;
      height: 4rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/information/orderdetail.vue